import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'

import { Observable } from 'rxjs'

import { FacetToggleEvent } from '../models/facet-toggle-event';
import { AppliedFacets } from '../models/applied-facets'

const delimiter = '-'

@Injectable()
export class FacetRoutingService extends Observable<AppliedFacets> {
    constructor(
        private router: Router,
        private route: ActivatedRoute
    ) { 
        super()

        this.source = route.queryParams.pipe(
            map(this.parseFacets))
    }

    private get commands(): string[] {
        return this.route.snapshot.url.map(seg => seg.path)
    }

    private get queryParams(): { [k: string]: any } {
        return this.route.snapshot.queryParams
    }

    private parseFacets(params: { [k: string]: any }): AppliedFacets {
        return Object.keys(params)
            .reduce(
                (prev, curr) => Object.assign(
                    prev,
                    {
                        [curr]: params[curr].split(delimiter)
                    }
                ),
                {} as AppliedFacets
            )
    }

    public toggleFacet(facet: FacetToggleEvent) {
        this.router.navigateByUrl(
            this.router.createUrlTree(
                this.commands,
                {
                    relativeTo: this.route,
                    queryParams: this.mergeSingle(facet),
                    queryParamsHandling: null,
                }
            )
        )
    }

    private mergeSingle(facet: FacetToggleEvent): { [k: string]: any } {
        let current = {...this.queryParams}
        let applied = current[facet.group]

        if(applied && FacetRoutingService.isInString(applied, facet.code)){
            let newFacets = applied.split(delimiter)
                .filter(appliedFacet => appliedFacet !== facet.code)

            if(!newFacets.length)
                delete current[facet.group]
            else
                current[facet.group] = newFacets.join(delimiter)
        } else if(applied) {
            current[facet.group] = `${current[facet.group]}${delimiter}${facet.code}`
        } else {
            current = Object.assign(
                current,
                {
                    [facet.group]: facet.code
                }
            )
        }

        return current
    }

    private static isInString(searchValue: string, value:string): boolean {
        let first = searchValue.indexOf(`${delimiter}${value}`) !== -1
        let middle = searchValue.indexOf(`${delimiter}${value}${delimiter}`) !== -1
        let last = searchValue.indexOf(`${value}${delimiter}`) !== -1
        
        return searchValue === value ||
            (middle || last && !first || first && !last)
    }
}
